import type { PurchaseItem } from "../models/Purchase";
export function allPurchaseItemsPaid(items: PurchaseItem[]): boolean {
  return items.length > 0 && items.every(line => line.PaymentStatus === "Paid");
}
export function validatePurchaseReceiving(items: PurchaseItem[], receiving: boolean): string {
  return receiving && !allPurchaseItemsPaid(items)
    ? "All purchase items must be Paid before adding stock to inventory." : "";
}
